import { defineMessages } from 'react-intl';

export const messages: {
	filterSpotlightMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsSpotlightMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	okButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exploreListViewButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	applySettingsButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spaceNameFallback: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsImageAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsImageAltTextCurrentSpace: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsImageAltTextNo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headingContentRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionContentRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsDescriptionContentRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsYesSingleSpaceContentRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsYesAllSpacesContentRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsNoContentRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyListSettingsNoDescriptionContentRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterSpotlightMessage: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.filter',
		defaultMessage: 'Search, filter, and group work items to quickly find what you need.',
		description: 'Message for filter bar on Issue Table',
	},
	dismissButton: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button for the list merge spotlight',
	},
	nextButton: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.next',
		defaultMessage: 'Next',
		description: 'Next button for the list merge spotlight',
	},
	moreActionsSpotlightMessage: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions',
		defaultMessage:
			'Adjust how you visualise the work with charts and format rules. You can also apply your old list settings.',
		description: 'Message for more actions button on Issue Table',
	},
	okButton: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.ok',
		defaultMessage: 'OK',
		description: 'OK button for the list merge spotlight',
	},
	exploreListViewButtonLabel: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label',
		defaultMessage: 'Explore List view',
		description: 'Explore List View button for the list merge spotlight',
	},
	applySettingsButtonLabel: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.apply-settings-button-label',
		defaultMessage: 'Apply settings',
		description: 'Apply settings button for the list merge modal that begins the tour',
	},
	spaceNameFallback: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spaceNameFallback',
		defaultMessage: 'current',
		description: 'Fallback for the space name in the list merge modal onboarding modal',
	},
	copyListSettingsImageAltText: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltText',
		defaultMessage:
			'Illustration of multiple spaces stacked to show everything will migrate together.',
		description: 'Alt text for the image in the list merge modal onboarding modal from all spaces',
	},
	copyListSettingsImageAltTextCurrentSpace: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextCurrentSpace',
		defaultMessage:
			'Illustration of a single space showing the list settings will migrate to the new view.',
		description:
			'Alt text for the image in the list merge modal onboarding modal from current space',
	},
	copyListSettingsImageAltTextNo: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextNo',
		defaultMessage:
			'Illustration of a cursor selecting the More actions menu to choose migrate later.',
		description: 'Alt text for the image in the list merge modal onboarding modal from no spaces',
	},
	headingContentRefresh: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.headingContentRefresh',
		defaultMessage: 'A single, more powerful List view',
		description: 'Refers to heading - Heading for the list merge modal onboarding modal',
	},
	descriptionContentRefresh: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.descriptionContentRefresh',
		defaultMessage:
			"We've combined the best of List and All work into <link>one powerful, unified view for managing work items.</link>",
		description: 'Description for the list merge modal onboarding modal',
	},
	copyListSettingsDescriptionContentRefresh: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescriptionContentRefresh',
		defaultMessage:
			"Want to use the same settings that you're currently using in List? This includes filters, groups and columns you've set.",
		description:
			'Refers to copyListSettingsDescription - Description to give context to the user so that they can choose which settings they want to use in the new view',
	},
	copyListSettingsYesSingleSpaceContentRefresh: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesSingleSpaceContentRefresh',
		defaultMessage: 'Apply current settings for {spaceName} space only',
		description:
			'Refers to copyListSettingsYesSingleSpace - Label for the yes to migrating current space button in the list merge modal onboarding modal',
	},
	copyListSettingsYesAllSpacesContentRefresh: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesAllSpacesContentRefresh',
		defaultMessage: 'Apply current settings for all spaces I use',
		description:
			'Refers to copyListSettingsYesAllSpaces - Label for the yes to migrating all spaces button in the list merge modal onboarding modal',
	},
	copyListSettingsNoContentRefresh: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoContentRefresh',
		defaultMessage: "Don't apply current settings",
		description:
			'Refers to copyListSettingsNo - Label for the no button in the list merge modal onboarding modal',
	},
	copyListSettingsNoDescriptionContentRefresh: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoDescriptionContentRefresh',
		defaultMessage: 'Update settings later in More actions (...)',
		description:
			'Refers to copyListSettingsNoDescription - Description for the no button in the list merge modal onboarding modal',
	},
	closeButton: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.closeButton',
		defaultMessage: 'Close',
		description: 'Label for the close button in the list merge modal onboarding modal',
	},
});
